export interface ProductTranslation {
  name: string;
  description?: string;
  details?: string;
}

export interface Product {
  id: number;
  translations: {
    en: ProductTranslation;
    he: ProductTranslation;
  };
  price?: number;
  previous_price?: number;
  image: string;
  images?: string[]; // Add images array for multiple product images
  details?: string; // Optional long description
  sku?: string;  // Stock Keeping Unit - useful for inventory management
  inStock?: boolean;
  category?: string;
  brand?: string; // Add brand for filtering by brand
  createdAt?: string;
  updatedAt?: string;
  specs?: { label: string; value: string }[];
}

export const products: Product[] = [
  {
    id: 1,
    translations: {
      en: {
        name: 'Lamps',
        description: 'Set of LED lamps'
      },
      he: {
        name: 'נורות',
        description: 'סט נורות לד'
      }
    },
    price: 999,
    image: '/pictures/4_lamps.avif',
    inStock: true,
    category: 'accessories',
    brand: 'blueboard'
  },
  {
    id: 2,
    translations: {
      en: {
        name: 'T Key',
        description: 'T-shaped adjustment key'
      },
      he: {
        name: 'מפתח T',
        description: 'מפתח כוונון בצורת T'
      }
    },
    price: 999,
    image: '/pictures/t_tool.avif',
    inStock: true,
    category: 'accessories',
    brand: 'blueboard'
  },
  {
    id: 3,
    translations: {
      en: {
        name: 'Blue Board',
        description: 'Professional Blue Board system',
        details: `The Bboard features a deck made from 9 layers of flexible, ultra-strong bamboo, supporting up to 300kg, with a coarse grip for maximum traction.

It comes with four 105mm magnesium wheels and perforated rubber tires for shock absorption—no risk of flats.

Powered by two rear hub motors (total 1500W), the Bboard is reliable, belt-free, and maintenance-light.

A smart ESC controller perfectly synchronizes both motors, delivering high power and precise control, with three speed modes (up to 25–45 km/h) and the ability to climb 30° hills with ease.

The wireless remote uses radio waves and features an LCD display for ride stats and battery levels (board and remote). Charges via USB Type-C.

The Bboard includes a 36V lithium-ion battery (7Ah, upgradeable to 10Ah) for a range of 15–25 km, and a lightweight, reliable charger (full charge in 3–4 hours).

Accessories (sold separately):
- LED light set (2 front white, 2 rear red)
- T-tool for adjustments and maintenance.`
      },
      he: {
        name: 'בלו בורד',
        description: 'מערכת בלו בורד מקצועית'
      }
    },
    price: 6500,
    previous_price: 8500,
    image: '/pictures/02000.png',
    inStock: true,
    category: 'electric-skateboard',
    brand: 'blueboard',
    details: `ה Bboard מגיע עם קרש שעשוי מ 9 שכבות של במבוק גמיש וחזק במיוחד, שמקנה לו את היכולת לשאת משקל של עד 300 ק"ג. ועליו גריפ גרפית גס שנותן אחיזה חזקה בקרש.

ה Bboard מגיע עם ארבעה גלגלי מגנזיום בקוטר 105 מ"מ וצמיגי גומי מחורר וגמיש, שמאפשרים שיכוך אך ללא סיכון לפנצ'ר.

ה Bboard מצויד בשני מנועי האב-מוטור (hub-motor) שנמצאים בשני הגלגלים האחוריים, שמייצרים ביחד הספק של 1500 וואט (watt) , חזקים ואמינים ביותר ללא התעסקות ברצועות ומתאמים.

ה Bboard נתמך על ידי בקר (esc) שמסנכרן בין שני המנועים בצורה מושלמת, ויודע להוציא מהמנועים הספקים גבוהים במהירות, ולשלוט בצורה חכמה ומדויקת ברכיבה על ה Bboard ולהגיע למהירות של 25-45 קמ"ש. (על ידי 3 דרגות מהירות) ולעלות עליות קשות של 30 מעלות בקלילות.

ה Bboard נשלט בידי שלט אלחוטי שעובד על גלי רדיו, ומצויד במסך LCD שמציג מידע וביצועים אודות הרכיבה ומצב הסוללות בסקייטבורד ובשלט. והוא נטען באמצעות מטען Type-C

ה Bboard מגיע עם סוללת ליטיום- יון (Lithium-ion) 36V בקיבולת של 7 אמפר (ניתן לשדרג עד 10 אמפר) , ולהגיע לטווח נסיעה של 15-25 ק"מ.

ה Bboard מגיע עם מטען, אמין וקל במיוחד שטוען את הסוללה בין 3-4 שעות לטעינה מלאה

מוצרים משלימים :

ניתן לרכוש בנפרד סט פנסים (2 קידמי לבנים, 2 אחוריים אדומים)
מפתח T-tool עבור כיוון ותחזוקה של הסקייטבורד`
  },
  {
    id: 4,
    translations: {
      en: {
        name: 'Remote Control',
        description: 'Wireless remote control'
      },
      he: {
        name: 'שלט',
        description: 'שלט אלחוטי'
      }
    },
    price: 9999,
    image: '/pictures/remote_control.avif',
    inStock: true,
    category: 'accessories',
    brand: 'blueboard'
  },
  {
    id: 5,
    translations: {
      en: {
        name: '36V Charger',
        description: '36V power adapter'
      },
      he: {
        name: 'מטען V 36',
        description: 'ספק כוח 36 וולט'
      }
    },
    price: 999,
    image: '/pictures/charger.avif',
    inStock: true,
    category: 'accessories',
    brand: 'blueboard'
  }
];
